<div class="modal">
    <div class="header">
        <h1 translate [translateParams]="{name: group.name}" *ngIf="group?.name" class="title">PREMIUM_ADMIN_MEMBER_MODAL_ATTACH_MEMBER_TO_GROUP</h1>
        <div class="close-button" (click)="close()"></div>
    </div>
    <div class="body">
        <ng-container *ngIf="(attachMemberFromGroupPending$ | async); else notProcessing">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #notProcessing>
            <div class="section">
                <form class="form" [formGroup]="attachMemberForm" (ngSubmit)='onSubmit()'>
                    <div class="input">
                        <ng-select (click)="$event.stopPropagation()" [items]="attachableMembers" bindLabel="username" [searchable]="true"
                            [multiple]="false" [clearable]="true" [addTag]="addEmail"
                            placeholder="{{ 'PREMIUM_ADMIN_MEMBER_MODAL_ATTACH_MEMBER_TO_GROUP_PLACEHOLDER_MEMBER' | translate }}"
                            formControlName="member" [(ngModel)]="selectedMember">
                            <ng-template ng-tag-tmp let-search="searchTerm">
                                <b>Ajouter l'email</b> : {{search}}
                            </ng-template>
                        </ng-select>
                    </div>
                </form>
            </div>
        </ng-template>
    </div>
    <div class="footer">
        <button class="btn-new white" type="submit" (click)="close()"
            [disabled]="(attachMemberFromGroupPending$ | async)">{{'PREMIUM_ADMIN_MEMBER_MODAL_ATTACH_MEMBER_TO_GROUP_BUTTON_LABEL_CANCEL' |
            translate}}</button>
        <button class="btn-new red" type="submit" (click)="onSubmit()"
            [disabled]="!f.member.value || (attachMemberFromGroupPending$ | async)">{{'PREMIUM_ADMIN_MEMBER_MODAL_ATTACH_MEMBER_TO_GROUP_BUTTON_LABEL_ATTACH'
            | translate}}</button>
    </div>
</div>